import React from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useSite from 'sites/contexts/sites';
import FormInput from 'common/components/FormInput/FormInput';
import MultilingualInput from 'common/components/MultilingualInput/MultilingualInput';

import SiteSelect from 'sites/components/SiteSelect';
import FormScrollError from 'common/components/FormScrollError/FormScrollError';
import Button from 'common/components/Button/Button';
import fetchJSON from 'common/utils/fetchJSON';

const CategoryItemForm = ({ onSubmit, categoryItem }) => {
  const { t, i18n } = useTranslation();
  const { currentSite } = useSite();

  if (currentSite && categoryItem && categoryItem.id && categoryItem.site?.id !== currentSite.id) {
    return (<h1>{t('common.notAllowed')}</h1>);
  }

  const handleTranslate = async (values, setFieldValue) => {
    let translated;
    const { name } = values;

    if (name) {
      translated = await fetchJSON({
        url: 'sites/translate',
        method: 'POST',
        payload: { items: { name }, site: currentSite.id },
      });

      setFieldValue({
        field: 'name',
        value: translated.name,
      });
    }
  };

  // eslint-disable-next-line camelcase
  const defaultLang = categoryItem ? categoryItem.site?.default_language : (
    currentSite ? currentSite.default_language : i18n.language);

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={categoryItem?.id ? {
        ...categoryItem,
        site: categoryItem?.site?.id,
      } : { site: currentSite ? currentSite.id : null }}
      mutators={{
        setFieldValue: ([field], state, utils) => {
          utils.changeValue(state, field.field, () => field.value);
        },
      }}
      render={({
        values, handleSubmit, submitting, pristine, form,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <FormScrollError />
          <Button
            style={{ marginBottom: '2rem' }}
            label="Translate"
            icon="fa-language"
            color="primary"
            confirm
            confirmMessage={t('common.translateConfirm')}
            onClick={() => handleTranslate(values, form.mutators.setFieldValue)}
          />
          <MultilingualInput
            name="name"
            label={t('common.name')}
            icon="heading"
            value={values.name}
            defaultLang={defaultLang}
            required
          />
          {!currentSite && (
          <FormInput
            type="custom"
            name="site"
            label={t('common.site')}
            required
          >
            <SiteSelect />
          </FormInput>
          )}
          <FormInput
            type="submit"
            label={t('common.save')}
            icon="map-pin"
            disabled={submitting || pristine}
          />
        </form>
      )}
    />
  );
};

CategoryItemForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  categoryItem: PropTypes.object,
};

CategoryItemForm.defaultProps = {
  categoryItem: {},
};

export default CategoryItemForm;
